import React, { useEffect, useRef, useState } from 'react'
import { PRE_CHECK_MACHINE_STATES } from '../constants'
import useStudentPreChecks from '../useStudentPreChecks'
import useWindowEvents from '../useWindowEvents'
import { VOLUME_CHECK_MODE } from './StudentVolumeChecksConstants'
import VolumeCheckModes from './VolumeCheckModes'
 
export default function StudentVolumeChecks(props) {

    /**
     * props
     */
    const { speechProps, toggleReaderContainer, showMicIcon } = props

    /**
    * states
    */
    const [currentMode, setCurrentMode] = useState(VOLUME_CHECK_MODE.STUDENT)

    /**
     * hooks
     */
    useWindowEvents()
    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks });
    const { isCurrent, currentError, settings } = studentPreCheck;

    /**
     * mutable values, remember to use refVariable.current to access or mutate the value!
     */
    const checkStarted = useRef(false)
    const teacherCalled = useRef(false)
    const teacherTestSuccessful = useRef(false)

    /**
     * effects
     */
    useEffect(() => {
        if (isCurrent && checkStarted.current === false) {
            checkStarted.current = true
            studentPreCheck.startCheck()
        }
    }, [isCurrent])

    useEffect(()=>{
        speechProps.abortDance()
        speechProps.abortSpeech()
    }, [currentMode])

    const toggleTeacherMode = (isTeacherMode) => {
        if(isTeacherMode) setCurrentMode(VOLUME_CHECK_MODE.TEACHER)
        else setCurrentMode(VOLUME_CHECK_MODE.STUDENT)
    }

    /**
     * Rendering
     */
    const isTeacherMode = currentMode === VOLUME_CHECK_MODE.TEACHER
    
    if (!studentPreCheck.isCurrent) return null

    if( isTeacherMode ){
        return <VolumeCheckModes 
        key="volume-check-teacher-mode"
        speechProps={speechProps} 
        toggleReaderContainer={toggleReaderContainer}
        showMicIcon={showMicIcon}
        teacherCalled={teacherCalled}
        isTeacherMode={isTeacherMode} 
        teacherTestSuccessful={teacherTestSuccessful}
        toggleTeacherMode={toggleTeacherMode}/>
    }
    
    return <VolumeCheckModes 
        key="volume-check-student-mode"
        speechProps={speechProps} 
        toggleReaderContainer={toggleReaderContainer}
        showMicIcon={showMicIcon}
        teacherCalled={teacherCalled}
        teacherTestSuccessful={teacherTestSuccessful}
        isTeacherMode={isTeacherMode} 
        toggleTeacherMode={toggleTeacherMode}/>
}